import React from "react";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert, { AlertProps } from "@mui/material/Alert";

interface ToastMessageProps {
  open: boolean;
  message: string;
  severity?: "success" | "info" | "warning" | "error";
  duration?: number;
  onClose: () => void;
}

const Alert = React.forwardRef<HTMLDivElement, AlertProps>(
  function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
  }
);

const ToastMessage: React.FC<ToastMessageProps> = ({
  open,
  message,
  severity = "info",
  duration = 3000,
  onClose,
}) => {
  return (
    <Snackbar
      open={open}
      autoHideDuration={duration}
      onClose={onClose}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
    >
      <Alert
        onClose={onClose}
        severity={severity}
        sx={{
          paddingLeft: "20px",
          paddingRight: "20px",
          display: "flex",
          alignItems: "center",
          "& .MuiAlert-icon": {
            display: "flex",
            alignItems: "center",
            padding: 0,
            marginRight: "12px",
          },
          "& .MuiAlert-message": {
             padding: "8px 0"
          },
          "& .MuiAlert-action": {
            padding: 0,
            alignItems: "center"
          }
        }}
      >
        {message}
      </Alert>
    </Snackbar>
  );
};

export default ToastMessage;
